export default __webpack_public_path__ + "static/media/user.5385d6d4.png";